import React from "react";
import PropTypes from "prop-types";
import { FileXCorner } from "lucide-react";

import { UIEmptyState } from "../../../ui";
import { TIMESHEET_EMPTY_STATE_VARIANTS } from "./constants";

import "./TimesheetEmptyState.scss";

const TimesheetEmptyState = ({ variant, copy }) => {
  const content = copy.emptyStates[variant] || copy.emptyStates.event;

  return (
    <UIEmptyState
      title={content.title}
      description={content.description}
      icon={<FileXCorner size={40} strokeWidth={1.5} />}
      classNames={{
        root: "timesheet-empty-state",
        description: "timesheet-empty-state__description",
        iconCircle: "timesheet-empty-state__icon-circle",
      }}
    />
  );
};

TimesheetEmptyState.propTypes = {
  variant: PropTypes.oneOf(Object.values(TIMESHEET_EMPTY_STATE_VARIANTS)),
  copy: PropTypes.shape({
    emptyStates: PropTypes.object.isRequired,
  }).isRequired,
};

TimesheetEmptyState.defaultProps = {
  variant: TIMESHEET_EMPTY_STATE_VARIANTS.event,
};

export default TimesheetEmptyState;
